import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import ttl from './ttl'

Vue.use(Vuex)

let KEY = 'ACCESS_TOKEN_v4'
let KEY_OBJECTS = 'OBJECTS-v5'
let OLD_OBJECTS = ['OBJECTS-v4', 'OBJECTS-v3', 'OBJECTS-v2', 'OBJECTS', 'TRANSPORTERS', 'LOCATIONS']
OLD_OBJECTS.forEach(o => {
  localStorage.removeItem(o)
})
axios.defaults.baseURL = process.env.API_URL
axios.defaults.timeout = 300 * 1000

let trCodes = `APM\tCO
ATHA\tLocal
BDA\tNational
CCPL\tCO
CNL\tOthers
CTS\tLocal
CUST\tWH
DEL\tNational
EXP\tWH
FSC\tNational
GAT\tNational
INNO\tLocal
KAWL\tLocal
MGT\tLocal
MPLOG\tLocal
MTC\tLocal
NLPL\tWH
NPD\tOthers
OML\tNational
RAJ\tLocal
REF\tLocal
RTS\tLocal
SPJ\tCO
SPN\tNational
SYL\tLocal
TLI\tWH
TRNS\tLocal
TVS\tWH
TZL\tLocal
VRC\tCO
VTS\tNational
XPS\tNational`
let trMap = {}

function populateTrMap () {
  console.log('populate trMap')
  trCodes.split('\n').map(l => l.trim()).map(l => l.split('\t'))
    .forEach(l => {
      trMap[l[0]] = l[1]
    })
  console.log(trMap)
}

populateTrMap()

export default new Vuex.Store({
  state: {
    count: 0,
    tab: 0,
    loggedIn: false,
    adminLoggedIn: false,
    localAdmin: false,
    isTransporter: false,
    isCustomer: false,
    isRegularUser: false,
    ewbTenant: false,
    podTenant: false,
    accessToken: null,
    userType: 'CONSIGNOR',
    tenant: {},
    user: {permissions: [], admin: false},
    period: 'current',
    fromDate: moment().startOf('month').toDate(),
    toDate: moment().toDate(),
    transporters: [],
    locations: [],
    divisions: [],
    customers: [],
    downloadImages: [],
    keyValues: [],
    group: 0,
    division: 0,
    aggregate: 'COUNT',
    saleTypes: ['SAL', 'STR', 'SAM'],
    dashLocation: 0,
    dashTransporter: 0
  },
  mutations: {
    addToDownloadQueue (state, url) {
      state.downloadImages.push(url)
    },
    removeFromDownloadQueue (state, url) {
      state.downloadImages.splice(state.downloadImages.indexOf(url), 1)
    },
    clearDownloadQueue (state) {
      state.downloadImages = []
    },
    setHomePageDate (state, data) {
      state.period = data.period
      state.fromDate = data.fromDate
      state.toDate = data.toDate
      state.dashLocation = data.dashLocation
      state.dashTransporter = data.dashTransporter
      state.division = data.division
      state.group = data.group
      state.aggregate = data.aggregate
      state.saleTypes = data.saleTypes
    },
    increment (state) {
      state.count++
    },
    setTab (state, newTab) {
      state.tab = newTab
    },
    loggedIn (state, accessToken) {
      state.loggedIn = true
      state.accessToken = accessToken['authToken']
      state.adminLoggedIn = accessToken['admin']
      localStorage.setItem(KEY, JSON.stringify(accessToken))
      axios.defaults.headers.common['x-auth-token'] = accessToken['authToken']
    },
    loggedOut (state) {
      state.loggedIn = false
      state.adminLoggedIn = false
      state.localAdmin = false
      state.accessToken = null
      state.tenant = {}
      state.period = 'current'
      state.group = 0
      state.division = 0
      state.fromDate = moment().startOf('month').toDate()
      state.toDate = moment().toDate()
      state.downloadImages = []
      localStorage.removeItem(KEY)
      axios.defaults.headers.common['x-auth-token'] = null
    },
    saveTenant (state, tenant) {
      state.tenant = tenant
      localStorage.setItem('TENANT', JSON.stringify(tenant))
      if (state.tenant.tenantFeatures) {
        console.log('tenant features', state.tenant.tenantFeatures)
        state.ewbTenant = state.tenant.tenantFeatures.indexOf('EWB') > -1
        state.podTenant = state.tenant.tenantFeatures.indexOf('POD') > -1
      } else {
        console.log('tenant features missing')
      }
    },
    saveUser (state, user) {
      state.user = user
      state.userType = user['whomType'] || 'CONSIGNOR'
      state.localAdmin = user.localAdmin
      state.adminLoggedIn = user.admin
      state.isTransporter = state.userType === 'TRANSPORTER'
      state.isRegularUser = state.userType === 'REGULAR_USER'
      state.isCustomer = state.userType === 'CONSIGNEE'
      console.log('savingUser', user)
      console.log('admin?', state.adminLoggedIn, 'user?', state.isRegularUser, 'transporter?', state.isTransporter, 'customer?', state.isCustomer)
      localStorage.setItem('USER', JSON.stringify(user))
    },
    saveKeyValues (state, items) {
      state.keyValues = items
    },
    addKeyValue (state, item) {
      let existing = state.keyValues.filter(kv => kv.theKey === item.theKey)
      if (existing.length === 0) {
        state.keyValues.push(item)
      } else {
        existing[0].theValue = item.theValue
      }
    },
    removeKeyValue (state, item) {
      _.remove(state.keyValues, kv => kv.theKey === item.theKey)
    },
    saveTransporter (state, transporters) {
      state.transporters = transporters
    },
    saveLocation (state, user) {
      state.locations = user
    },
    saveCustomer (state, user) {
      state.customers = user
    },
    saveDivisions (state, user) {
      state.divisions = user.map(d => {
        return {group: d.group.trim(), division: d.division.trim()}
      })
    }
  },
  actions: {
    isLoggedIn (context) {
      let at = localStorage.getItem(KEY)
      console.log('Found AuthToken?', at)
      return new Promise((resolve, reject) => {
        if (at) {
          let j = JSON.parse(at)
          context.commit('loggedIn', j)
          axios.defaults.headers.common['x-auth-token'] = j['authToken']
          if (context.state.locations.length === 0) {
            console.log('empty state, will populate defaults')
            // check in localstorage
            let objects = ttl.get(KEY_OBJECTS)
            if (!objects) {
              axios.all([
                axios.get('/pod-app/key-values'),
                axios.get('/pod-app/transporters'),
                axios.get('/pod-app/locations'),
                axios.get('/pod-app/customers'),
                axios.get('/pod-app/divisionsList'),
                axios.get('/app/user/me'),
                axios.get('/app/tenant')
              ]).then(axios.spread(function (kv, tr, loc, cust, dl, me, ten) {
                context.commit('saveUser', me.data)
                context.commit('saveLocation', loc.data)
                context.commit('saveCustomer', cust.data)
                context.commit('saveDivisions', dl.data)

                let transporters = tr.data.map(t => {
                  t['type'] = trMap[t.code] || ''
                  return t
                })
                console.log(tr.data)
                console.log(transporters)
                context.commit('saveTransporter', transporters)
                context.commit('saveKeyValues', kv.data)
                context.commit('saveTenant', ten.data)
                ttl.set(KEY_OBJECTS, {
                  user: me.data,
                  locations: loc.data,
                  customers: cust.data,
                  divisions: dl.data,
                  transporters: transporters,
                  keyValues: kv.data,
                  tenant: ten.data
                }, 24 * 60 * 60 * 1000)
                resolve()
              }))
            } else {
              context.commit('saveUser', objects['user'])
              context.commit('saveLocation', objects['locations'])
              context.commit('saveCustomer', objects['customers'])
              context.commit('saveDivisions', objects['divisions'])
              context.commit('saveTransporter', objects['transporters'])
              context.commit('saveKeyValues', objects['keyValues'])
              context.commit('saveTenant', objects['tenant'])

              resolve()
            }
          } else {
            console.log(`state is already populated, location [${context.state.locations.length}] transporters [${context.state.transporters.length}]`)
            resolve()
          }
        } else {
          reject(Error('authToken not found'))
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js